import { Tabs } from 'antd';
import React, { ComponentProps } from 'react';
import { CustomerLookupContactModalTab } from './CustomerLookupContactModal';
import { tab } from '@testing-library/user-event/dist/tab';
import { customerLookupMessages } from 'messages/customer-lookup.message';
import ContactCustomersTab from './ContactOverviewCustomersTab';
import ContactInprogressTicketTab from './ContactOverviewInprogressTicketTab';
import ContactCompletedTicketTab from './ContactOverviewCompletedTicketTab';
import ContactHistoriesTab from './ContactOverviewHistoriesTab';
import { useTicketsInProgressCustomerLookupCount } from 'hooks/tickets/useTicketsInProgressCustomerLookupCount';
import { useContactCustomersCount, useContactHistoriesCount } from 'hooks/contacts';
import { useTicketsCompleteCustomerLookupCount } from 'hooks/tickets';

type ContactOverviewProps = {
  contactId: number;
  tabKey?: CustomerLookupContactModalTab;
  setTabKey?: (key: CustomerLookupContactModalTab) => void;
  searchCriteria?: any;
  handleCustomerCodeClick?: (customerCode: string) => void;
};

const ContactOverview: React.FC<ContactOverviewProps> = ({
  contactId,
  tabKey,
  setTabKey,
  searchCriteria,
  handleCustomerCodeClick
}) => {
  const { count: totalTicketsInProgress } = useTicketsInProgressCustomerLookupCount({
    administrativeUnitId: searchCriteria?.administrativeUnitId,
    contactId: contactId
  });

  const { count: totalCompletedTickets } = useTicketsCompleteCustomerLookupCount({
    administrativeUnitId: searchCriteria?.administrativeUnitId,
    contactId: contactId
  });

  const { count: totalContactCustomers } = useContactCustomersCount({
    contactId: contactId
  });

  const { count: totalContactHistories } = useContactHistoriesCount({
    contactId: contactId
  });

  const items: ComponentProps<typeof Tabs>['items'] = [
    {
      key: CustomerLookupContactModalTab.CUSTOMERS,
      label: (
        <div>
          <span>{customerLookupMessages.customersCode}</span>
          <span className='contact-count'>{totalContactCustomers}</span>
        </div>
      ),
      children: <ContactCustomersTab handleCustomerCodeClick={handleCustomerCodeClick} contactId={contactId} />
    },
    {
      key: CustomerLookupContactModalTab.IN_PROGRESS_TICKETS,
      label: (
        <div>
          <span>{customerLookupMessages.inprogressTickets}</span>
          <span className='contact-count'>{totalTicketsInProgress}</span>
        </div>
      ),
      children: (
        <ContactInprogressTicketTab
          handleCustomerCodeClick={handleCustomerCodeClick}
          searchCriteria={searchCriteria}
          contactId={contactId}
        />
      )
    },
    {
      key: CustomerLookupContactModalTab.COMPLETE_TICKETS,
      label: (
        <div>
          <span>{customerLookupMessages.completedTickets}</span>
          <span className='contact-count'>{totalCompletedTickets}</span>
        </div>
      ),
      children: (
        <ContactCompletedTicketTab
          handleCustomerCodeClick={handleCustomerCodeClick}
          searchCriteria={searchCriteria}
          contactId={contactId}
        />
      )
    },
    {
      key: CustomerLookupContactModalTab.HISTORY,
      label: (
        <div>
          <span>{customerLookupMessages.contactHistories}</span>
          <span className='contact-count'>{totalContactHistories}</span>
        </div>
      ),
      children: <ContactHistoriesTab contactId={contactId} handleCustomerCodeClick={handleCustomerCodeClick} />
    }
  ];

  return (
    <div className='flex w-full flex-1'>
      <Tabs
        activeKey={tabKey}
        prefixCls='contact-custom'
        style={{ width: '100%' }}
        items={items}
        defaultActiveKey='customers'
        destroyInactiveTabPane
        onChange={(key) => setTabKey?.(key as CustomerLookupContactModalTab)}
      />
    </div>
  );
};

export default ContactOverview;
